
<template>
  <div class="dsf-login-quick">
    <div class="login-box-info">
      <el-input
        v-model.trim="username"
        :disabled="$attrs.loading"
        :placeholder="$attrs.phonePlaceholder"
        size="medium"
        prefix-icon="iconfont icon-icon_phone"
        @input="handlePhone"
      >
      </el-input>
      <div
        v-show="showPhoneMessage"
        style="color: red; font-size: 13px; margin-top: 5px"
      >
        请输入正确的手机号码
      </div>
    </div>
    <div class="login-box-phonecode">
      <el-input
        v-model.trim="smsCode"
        :disabled="$attrs.loading"
        :placeholder="$attrs.passwordPlaceholder"
        size="medium"
        prefix-icon="iconfont icon-yanzhengma1"
      />
      <div
        class="phone-code"
        @click="handleGetCode"
        :class="{ iscoding: timer }"
      >
        <span
          :class="{ 'iscoding-click': codeClicking }"
        >{{ dsf.isString(codeString) ? codeString : codeString + "s" }}
        </span>
      </div>
    </div>
    <div class="login-box-info login-code" v-if="$attrs.isShowCode">
      <el-input
        v-model.trim="code"
        :disabled="$attrs.loading"
        type="text"
        :placeholder="$attrs.codePlaceholder"
        size="medium"
        prefix-icon="iconfont icon-yanzhengma1"
      />
      <img
        class="img-code"
        :src="$attrs.codeUrl"
        @click="$emit('updateCodeUrl')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "loginUser",
  data() {
    return {
      username: "",
      smsCode: "",
      code: "",
      showPhoneMessage: false,
      codeString: "获取验证码",
      timer: null,
      codeClicking: false, // 发送验证后再次点击
    };
  },
  methods: {
    // 验证手机号
    handlePhone() {
      if (dsf.validate("isMobile", this.username)) {
        this.showPhoneMessage = false;
      } else {
        this.showPhoneMessage = true;
      }
    },
    // 登陆时验证所有字段
    validateFiled() {
      this.username = _.trim(this.username);
      this.smsCode = _.trim(this.smsCode);
      if (this.username === "") {
        dsf.layer.message("手机号不能为空！", false);
        return false;
      }
      if (!dsf.validate("isMobile", this.username)) {
        dsf.layer.message("请输入正确的手机号！", false);
        return false;
      }
      if (this.smsCode === "") {
        dsf.layer.message("请输入手机验证码！", false);
        return false;
      }
      if (this.code === "" && this.$attrs.isShowCode) {
        dsf.layer.message("验证码不能为空！", false);
        return false;
      }
      return true;
    },
    // 获取手机验证码
    handleGetCode() {
      if (this.timer) {
        if (!this.codeClicking) {
          this.codeClicking = true;
          setTimeout(() => {
            this.codeClicking = false;
          }, 400);
        }
        return;
      }
      if (dsf.validate("isMobile", this.username)) {
        this.$http
          .post("user/quickLoginSendSms", { phone: this.username })
          .done((res) => {
            if (res.success) {
              this.codeString = 60;
              this.timer = setInterval(() => {
                if (dsf.isString(this.codeString)) {
                  this.codeString = 59;
                } else if (this.codeString > 0) {
                  this.codeString--;
                } else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.codeString = "获取验证码";
                }
              }, 1000);
            } else {
              dsf.layer.message(res.message, false);
            }
          });
      } else {
        dsf.layer.message("请输入正确的手机号", false);
      }
    },
    getLoginFileds() {
      let { username: userName, smsCode, code } = this;
      return {
        userName,
        smsCode,
        code: code || "good",
      };
    },
    handleClearCode() {
      this.code = ''
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
